import styled from "styled-components";

export const StyledIntroduceContent = styled.div`
display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 119px 8% 0;

  & > p {
    font-style: normal;
    font-weight: normal;
    font-size: 14.6462px;
    line-height: 18px;
    color: #626f81;
    margin-bottom: 16px;
    margin-top: 32px;
  }

  & > h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 42px;
    text-align: center;
    color: #ffffff;
    margin-bottom: 154px;
  }
  
  & > img {
    width: 100%;
    max-width: 420px;
    height: auto;
    margin: 0 auto -113px;
    box-shadow: 0px 24px 46px rgba(0, 0, 0, 0.199574);
  }

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    & > img {
      margin: 0 auto -113px 0;
      width: 35%;
      min-width: 230px;
    }
  }
  
  @media (min-width: ${({ theme }) => theme.queries.md}) {
    background-size: 100% auto;
    padding-left: 65px;
    padding-right: 65px;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    
    & > h3 {
      max-width: 740px;
      font-size: 56px;
      line-height: 56px;
      margin-bottom: 106px;
    }
    
    & > img {
      width: 40%;
      max-width: 420px;
      margin-bottom: -255px;
    }
  }
`;

export const StyledIntroduceSection = styled.div`
  background: url("./images/find-opponent1.png");
  background-blend-mode: multiply, multiply, normal;
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: 50% 0%;
  
  @media (min-width: ${({ theme }) => theme.queries.md}) {
    background-size: 100% auto;
  }
`;

export const StyledFindOpponent = styled.div`
  padding: 165px 8% 0;
  
  & > h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 30px;
    color: #233247;
  }

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    width: 50%;
    padding: 0 8% 0 0;
    margin: 70px 0 0 auto;
  }
`;

export const StyledOpponentsList = styled.div`
  display: flex;
  flex-direction: column;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  padding-left: 27px;
  color: #233247;
  
  & > p {
    margin-bottom: 20px;
    position: relative;
  }

  & > p:before {
    content: "";
    position: absolute;
    top: 11px;
    width: 11px;
    height: 1.5px;
    left: -25px;
    background: #233247;
  }
`;

export const StyledNetworkShop = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 52px;
  margin-bottom: 31px;
  max-width: 270px;
`;

export const AdaptiveImage = styled.img.attrs(props => {
    return {
        src:
            window.innerWidth > parseInt(props.theme.queries.sl, 10)
                ? "./images/find-opponent2-desktop.png"
                : "./images/find-opponent2.png"
    };
})``;























